/**
 * Branding in one place for the web app (the API's twin: apps/api/src/brand.ts). The product
 * name is a working name (PRD Q2 open); when it is
 * decided, change this file (and public/icons, manifest.webmanifest, index.html meta —
 * see docs/DESIGN.md "Rebranding"). Nothing else in the app hard-codes the name.
 * The tenant's own name comes from the session.
 */
export const BRAND = {
  /** Product name shown in the sidebar, sign-in and title bar. */
  product: 'ITCSI Parcel WMS',
  /** Short form for tight spots (installed app name, collapsed sidebar). */
  short: 'Parcel WMS',
  /** One line under the wordmark on the sign-in screen. */
  tagline: 'Every parcel, every step, one ID',
  /** Optional product logo (served from /public). Empty = the catalogue-drawer wordmark. */
  logoUrl: '' as string,
  /** Who runs the service, for the footer and Help. */
  operator: 'ITCORE Solutions Inc.',
  supportEmail: 'support@itcore-apps.com',
  /** Browser tab title suffix: "Find parcels – ITCSI Parcel WMS". */
  titleSuffix: 'ITCSI Parcel WMS',
} as const;

export const pageTitle = (title?: string): string => (title ? `${title} – ${BRAND.titleSuffix}` : BRAND.titleSuffix);
